module.exports = __webpack_public_path__ + "static/media/Parc5-5.c94f81e3.jpg";